export default __webpack_public_path__ + "static/media/plusNew.f2bf7dda.svg";